export const DEFAULT_FOLTER_NAME = 'all_competitions';
const BEST_FOLDER_NAME = 'best_projects';
export const DEFAULT_FOLDER = {
    id: DEFAULT_FOLTER_NAME,
    name: [{ lang: 'ru', name: 'Все конкурсы' }, { lang: 'en', name: 'All competitions' }],
    entityType: 'all_competitions',
    path: '/all_competitions',
}
export const BEST_FOLDER = {
    id: BEST_FOLDER_NAME,
    name: [{ lang: 'ru', name: 'Лучшие проекты' }, { lang: 'en', name: 'Best projects' }],
    entityType: 'best_projects',
    path: '/best_projects',
}export const DEFAULT_FOLTER_NAME = 'all_competitions';
const BEST_FOLDER_NAME = 'best_projects';
export const DEFAULT_FOLDER = {
    id: DEFAULT_FOLTER_NAME,
    name: [{ lang: 'ru', name: 'Все конкурсы' }, { lang: 'en', name: 'All competitions' }],
    entityType: 'all_competitions',
    path: '/all_competitions',
}
export const BEST_FOLDER = {
    id: BEST_FOLDER_NAME,
    name: [{ lang: 'ru', name: 'Лучшие проекты' }, { lang: 'en', name: 'Best projects' }],
    entityType: 'best_projects',
    path: '/best_projects',
}